import React from 'react';

interface BonusPeriodsContextType {
  bonusPeriods: BonusPeriod[] | BonusTypes.BonusPeriod[];
  selectedBonusPeriod?: BonusPeriod | BonusTypes.BonusPeriod;
  setSelectedBonusPeriod: (
    bp: BonusPeriod | BonusTypes.BonusPeriod | undefined,
  ) => void;
  /**
   * The selected calculation window within {@link selectedBonusPeriod}, for
   * programs using the sub-period pattern. Undefined for ordinary
   * single-window programs (the common case). Approvals ignores this and uses
   * the root period; boards/dashboards/reports and overrides operate on it.
   */
  selectedSubPeriod?: Period;
  setSelectedSubPeriod?: (sp: Period | undefined) => void;
}

const BonusPeriodsContext = React.createContext<BonusPeriodsContextType>({
  bonusPeriods: [],
  setSelectedBonusPeriod: () => {},
  setSelectedSubPeriod: () => {},
});

export default BonusPeriodsContext;
